export default "__VITE_ASSET__DyVHcI8O__"